import { useState, useRef, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { Mail, Lock, Eye, EyeOff, ArrowRight, Sparkles } from "lucide-react";
import axiosClient from "../api/axiosClient";
import axios from "axios";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import Swal from "sweetalert2";
//import { createUserObject } from "./script4.js";
import { createUserObject } from "../script/loginCreateuser.js";
//import "./LoginCSS.css"
import "../styles/Login.css";

const LoginForm = ({
  loading,
  setLoading,
  showPassword,
  setShowPassword,
  formData,
  handleChange,
  handleSubmit,
}) => {
  const navigate = useNavigate();
  const imageRef = useRef(null);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    // 🔥 Make LEFT-RIGHT stronger
    const rotateY = ((x - centerX) / centerX) * 22;

    // 🔥 Make UP-DOWN very small
    const rotateX = ((y - centerY) / centerY) * 4;

    imageRef.current.style.animation = "none";

    imageRef.current.style.transform = `
    perspective(1600px)
    rotateX(${-rotateX}deg)
    rotateY(${rotateY}deg)
    scale(1.1)
  `;
  };

  const resetTilt = () => {
    imageRef.current.style.animation =
      "autoFloat 3.5s cubic-bezier(0.4,0,0.2,1) infinite";
  };

  const loginWithGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setLoading(true);
      try {
        const res = await axios.post("/login/oauth2/code/google", {
          token: tokenResponse.access_token,
        });

        if (res.data.data) {
          const user = res.data.user;

          localStorage.setItem("token", res.data.token);

          localStorage.setItem(
            "user",
            JSON.stringify({
              id: user.id,
              name: user.name,
              email: user.email,
              plan: user.plan || "free",
              subscriptions: user.subscriptions || [],
            }),
          );

          localStorage.setItem("userId", user.id);

          // 🔥 ADD THIS (VERY IMPORTANT)
          localStorage.removeItem("testCompleted");
          localStorage.removeItem("reportTestName");
          localStorage.removeItem("selectedCourse");

          // 🔥 ---------------------CHECK IF DIFFERENT USER LOGIN
          const lastUser = localStorage.getItem("lastLoggedUser");

          if (lastUser && lastUser !== user.id) {
            localStorage.setItem("startFreshTest", "true");
          }

          // ✅ ---------------------Save current user as last logged user
          localStorage.setItem("lastLoggedUser", user.id);

          // ===================== YAHAN PASTE KARO =====================

          // 🔥 CLEAR OLD DATA AFTER GOOGLE LOGIN
          Object.keys(localStorage).forEach((key) => {
            if (key.startsWith("purchase_")) {
              localStorage.removeItem(key);
            }
          });

          localStorage.removeItem("demoActivated");

          // ============================================================

          const selectedCourse = localStorage.getItem("selectedCourse");

          if (selectedCourse) {
            localStorage.removeItem(`last_user_${selectedCourse}`);
          }

          if (res.data.newUser === true) {
            toast.success("Welcome! Setup your profile.");
            navigate("/onboarding");
          } else {
            toast.success("Google Login Successful!");
            const fromPopup = localStorage.getItem("fromPopup");
            const fromDaily = localStorage.getItem("fromDailyQuest");

            if (fromPopup === "true") {
              localStorage.removeItem("fromPopup");
              navigate("/courses");
            } else if (fromDaily === "true") {
              const resumeRaw = localStorage.getItem("resumeDailyQuest");

              if (resumeRaw) {
                const resume = JSON.parse(resumeRaw);

                if (resume?.course) {
                  navigate(`/daily?course=${encodeURIComponent(resume.course)}`);
                } else {
                  navigate("/daily");
                }
              } else {
                navigate("/daily");
              }

              localStorage.removeItem("fromDailyQuest");
            } else {
              navigate("/front");
            }
          }
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Google Login Failed",
          text: "Please try again later.",
          confirmButtonColor: "#6366f1",
        });
      } finally {
        setLoading(false);
      }
    },
    onError: () => toast.error("Google Login Failed"),
  });

  return (
    <div className="glass-card">
      {/*----------------------Left Section - Image ------------------ */}
      <div className="visual-panel">
        <div
          className="teddy-wrapper"
          onMouseMove={handleMouseMove}
          onMouseLeave={resetTilt}
        >
          <div className="light-layer"></div>
          <img
            ref={imageRef}
            src="Zesty Hii1.png"
            alt="Zesty Character"
            className="float-image"
          />
        </div>
        {/* <div className="brand-badge">
          <Sparkles size={16} /> Premium Experience
        </div> */}
        <div className="panel-text">
          <center>
            <h2>CodeMatrix</h2>
            <p>Unified, efficient, and scalable system.</p>
          </center>
        </div>
        <div className="visual-glow"></div>
      </div>

      {/*----------------------Right Section - Form ------------------ */}
      <div className="form-panel">
        <div className="form-head">
          <h1>Welcome Back</h1>
          <p>Step into your digital dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="premium-form">
          <div className="input-field">
            <label>Email Address</label>
            <div className="field-inner">
              <Mail className="field-icon" size={18} />
              <input
                type="email"
                name="email"
                placeholder="name@example.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="input-field">
            <div className="label-flex">
              <label>Security Key</label>
            </div>
            <div className="field-inner">
              <Lock className="field-icon" size={18} />
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="eye-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <Link
            to="/forget"
            className="forgot-pass"
            style={{ display: "block", marginBottom: "15px" }}
          >
            Forget Password ?
          </Link>

          <button type="submit" className="glamour-btn" disabled={loading}>
            <span className="btn-text">
              {loading ? "Validating..." : "Sign In Now"}
            </span>
            {!loading && <ArrowRight size={18} className="btn-arrow" />}
          </button>
        </form>

        <div className="form-foot">
          <p>
            Not a member yet? <Link to="/signup">Sign Up</Link>
          </p>
          <p>
            <Link to="/adminlogin">Admin Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};



export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axiosClient.post(
        "/no-auth/api/users/login",
        formData,
      );
      const data = response.data.data;

      // ✅ token fallback (PERMANENT FIX)
      const token = data?.token || data?.accessToken || data || null;

      if (!token) {
        throw new Error("Token not received from backend");
      }

      localStorage.setItem("token", token);

      const user = createUserObject(data, formData);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("userId", user.id);

      // ---------------------USER CHANGE DETECTION
      const lastUser = localStorage.getItem("lastLoggedUser");

      if (lastUser && lastUser !== user.id) {
        localStorage.setItem("startFreshTest", "true");
      }

      localStorage.setItem("lastLoggedUser", user.id);

      //------------------- MOST IMPORTANT – OLD USER DATA CLEAN
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("purchase_")) {
          localStorage.removeItem(key);
        }
      });

      localStorage.removeItem("demoActivated");

      //------------------------Navbar refresh signal
      window.dispatchEvent(new Event("user-login"));

      toast.success("Welcome back!");


      const fromPopup = localStorage.getItem("fromPopup");
      const fromDaily = localStorage.getItem("fromDailyQuest");

      // 🔥 PRIORITY 1 → Popup flow
      if (fromPopup === "true") {
        localStorage.removeItem("fromPopup");
        navigate("/courses"); // 👈 popup se aya user
      }

      // 🔥 PRIORITY 2 → DailyQuest resume
      else if (fromDaily === "true") {
        // const resumeRaw = localStorage.getItem("resumeDailyQuest");

          navigate("/daily");


        localStorage.removeItem("fromDailyQuest");
      }
    
      else {
        navigate("/front");
      }
        
    } catch (error) {
const status = error.response?.status;
const serverMsg = error.response?.data?.message?.toLowerCase() || "";


// ✅ BLOCKED USER FIRST
if (serverMsg.includes("blocked_user")) {
  Swal.fire({
    title: "Account Blocked!",
    text: "Your account has been blocked by the Administrator.",
    icon: "warning",
    confirmButtonText: "OK",
    confirmButtonColor: "#f5260b",
  });
}

// ✅ USER NOT FOUND
else if (
  serverMsg.includes("User")
) {
  Swal.fire({
    title: "User Not Found!",
    text: "This email is not registered. Please check or join the circle.",
    icon: "warning",
    confirmButtonText: "Try Again",
    confirmButtonColor: "#6366f1",
  });
}

// ✅ PASSWORD ERROR
else if (
  serverMsg.includes("password") ||
  serverMsg.includes("credential")
) {
  Swal.fire({
    title: "Password is Incorrect!",
    text: "Incorrect security key. Please double-check your password.",
    icon: "error",
    confirmButtonText: "Back to Login",
    confirmButtonColor: "#ef4444",
  });
}

// 401 token expire case
else if(status === 401){
   console.log("token expired");
  localStorage.removeItem("token");
  navigate("/login");
}

// ✅ OTHER ERRORS
else {
  Swal.fire({
    title: "Login Error",
    text: error.response?.data?.message || "Something went wrong.",
    icon: "question",
    confirmButtonColor: "#1e293b",
  });
}
      
    } finally {
      setLoading(false);
    }
  };

  return (
    <GoogleOAuthProvider clientId="631337239846-ttmko96e5b4fk8ifbhq4htqmdn8hji94.apps.googleusercontent.com">
      <div className="glamour-root">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <LoginForm
          loading={loading}
          setLoading={setLoading}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          formData={formData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
      </div>
    </GoogleOAuthProvider>
  );
}
